import React, { useMemo, useEffect, useState } from "react";
import Header1 from "./Header1";
import Categories from "./MainPageComponents.js/Categories";
import Categories1 from "./MainPageComponents.js/Categories1";
import Brands from "./MainPageComponents.js/Brands";
import FirstBlock from "./MainPageComponents.js/FirstBlock";
import MakeUp from "./Categories/MakeUp";
import MakeUpBlock from "./MainPageComponents.js/MakeUpBlock";
import ReviewsCategoryBlock from "./MainPageComponents.js/ReviewsCategoryBlock";
import SkinCareBlock from "./MainPageComponents.js/SkinCareBlock";
import HairCareBlock from "./MainPageComponents.js/HairCareBlock";
import HairColourBlock from "./MainPageComponents.js/HairColourBlock";
import BrandsBlock from "./MainPageComponents.js/BrandsBlock";
import PerfumeBlock from "./MainPageComponents.js/PerfumeBlock";
import { useTranslation } from "react-i18next";
import AllCategoriesRecentlyViewed from "./AllCategoriesComponents/AllCategoriesRecentlyViewed";
import Header3 from "./Header3";
export default function MainPage() {
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [MyWidth]);

  const { t, i18n } = useTranslation();

  const FirstBlockMemo = useMemo(() => {
    return <FirstBlock />;
  }, []);

  const PerfumeBlockMemo1 = useMemo(() => {
    return <PerfumeBlock CatCall={"Perfume"} />;
  }, []);
  const PerfumeBlockMemo2 = useMemo(() => {
    return <PerfumeBlock CatCall={"Makeup"} />;
  }, []);
  const PerfumeBlockMemo9 = useMemo(() => {
    return <PerfumeBlock CatCall={"Accessories"} />;
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        //backgroundColor: "red",
      }}
    >
      {/* {MyWidth <= 1024 ? <Header3 /> : <></>} */}

      {FirstBlockMemo}

      {/* <Brands /> */}
      {PerfumeBlockMemo1}
      {PerfumeBlockMemo9}

      {/* <SkinCareBlock />
      <MakeUpBlock />
      <HairCareBlock />
      <HairColourBlock />
      <ReviewsCategoryBlock /> */}
    </div>
  );
}
// {/* <Header /> */}
// {/* <Categories /> */}
// <FirstBlock />
// <Brands />
// <PerfumeBlock />
// <SkinCareBlock />
// <MakeUpBlock />
// <HairCareBlock />
// <HairColourBlock />
// {/* <BrandsBlock /> */}
// <ReviewsCategoryBlock />
